
import { Info } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface EmptyStateMessageProps {
  type: 'no-query' | 'no-results';
  query?: string;
}

const EmptyStateMessage = ({ type, query }: EmptyStateMessageProps) => {
  if (type === 'no-query') {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Enter a search term and press Search</p>
      </div>
    );
  }

  return (
    <Card className="text-center py-12">
      <CardContent>
        <Info className="mx-auto h-12 w-12 text-muted-foreground mb-4" />
        <h3 className="text-lg font-medium">No results found</h3>
        <p className="text-muted-foreground mt-2">
          No students or programs matched your search for "{query}".
        </p>
      </CardContent>
    </Card>
  );
};

export default EmptyStateMessage;
